
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Options, Vue } from "vue-class-component";

import HotspotContentList from "@/components/Common/HotspotContentList.vue";

@Options({
  components: {
    HotspotContentList,
  },
  props: {
    modules: Object,
  },
  inject: ["outsideIframeShow"],
  data() {
    return {
      rootUrl: process.env.VUE_APP_DEPLOY_URL,
    };
  },
  methods: {
    audiobgstop() {
      this.$emit("audiobgstop");
    },
    goUrl() {
      if (this.modules.url) {
        window.open(this.modules.url);
      }
    },
    click(k: number) {
      this.currentIndex = k;
      this.showDetail = true;
    },
  },
})
export default class Hotspot6 extends Vue {}
